import { useNavigate } from "react-router-dom";

export const AdminStudentProfileHeader = ({ student }) => {
    const navigate = useNavigate();
    return (
        <>
        <div className="mb-3">
            <button className="btn p-0 d-flex align-items-center"  onClick={() => navigate(-1)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" className="bi bi-arrow-left me-2" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H2.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 1 1 .708.708L2.707 7.5H14.5A.5.5 0 0 1 15 8z"/>
                </svg>
            </button>
        </div>
        <div className="card shadow-sm">
            <div className="card-body p-4">
                <div className="row align-items-center justify-content-center justify-content-md-start">
                    <div className="col-auto text-center mb-3 mb-md-0 d-flex flex-column align-items-center">
                        <img
                            src={`${process.env.REACT_APP_IMAGE_PATH}${student.profileImage}`}
                            // alt={student.name}
                            className="rounded-circle img-thumbnail"
                            style={{
                                width: "140px",
                                height: "auto",
                                minWidth: "140px",
                                minHeight: "140px",
                                objectFit: "cover",
                            }}
                        />
                    </div>

                    <div className="col-md-7 col-sm-9 col-12 text-lg-start text-md-start text-center">
                        <h3 className="mb-1">{student.name}</h3>
                        <p className="text-muted mb-2">
                            <i className="fas fa-user-graduate me-1"></i>
                            {student.email}
                        </p>
                    </div>
                    <div className="d-flex justify-content-md-end">
                        <div className="col-12 col-md-3 mt-3 mt-md-0">
                            <button className="btn btn-primary w-100">
                                <i className="fas fa-envelope me-2"></i>
                                Message
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>

    );
};